import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./auth/msalConfig";  // shared singleton from config
import AuthGuard from "./auth/AuthGuard";
import HomePage from "./components/HomePage/HomePage";
import OpticusLab from "./OpticusLab";
import SystemMessageManager from "./components/SystemMessageManager/SystemMessageManager";
import DomainRedirect from "./components/DomainRedirect";
import Assistant from "./components/Assistant/Assistant";
import { NeuProvider, useNeu } from "./context/NeuContext";


// Redirect component that navigates to the standalone validator HTML page
const ValidatorRedirect = () => {
  React.useEffect(() => {
    window.location.replace('/validator/index.html');
  }, []);
  return null;
};

const LtDemoRedirect = () => {
  React.useEffect(() => {
    window.location.replace('/demo.html');
  }, []);
  return null;
};

// Inner layout component — must be inside NeuProvider to read chatOpen
function AppLayout() {
  const { chatOpen } = useNeu();
  return (
    <>
      <div className={`app-content-wrapper${chatOpen ? ' app-content-wrapper--panel-open' : ''}`}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/playground" element={<OpticusLab />} />
          <Route path="/create-dataset" element={<Navigate to="/playground" replace />} />
          <Route path="/system-messages" element={<SystemMessageManager />} />
          <Route path="/validator" element={<ValidatorRedirect />} />
          <Route path="/lt-demo" element={<LtDemoRedirect />} />
        </Routes>
      </div>
      {/* Assistant rendered outside the push-wrapper so it never shifts */}
      <Assistant />
    </>
  );
}

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <>
        <DomainRedirect />
        <Router>
          <AuthGuard>
          <NeuProvider>
            <AppLayout />
          </NeuProvider>
          </AuthGuard>
        </Router>
      </>
    </MsalProvider>
  );
}

export default App;
